module.exports = __webpack_public_path__ + "files/61fd241332080253aad65f67a8c9b76b.png";